import {Button} from "../../../basic/button.tsx";
import {Label} from "../../../basic/label.tsx";
import {Trash2} from "lucide-react";
import {t} from "i18next";
import {VwpTeamMemberLicense} from "../../../../store/generated/api.ts";

interface LicenseListProps {
    licenses: VwpTeamMemberLicense[];
    onRemoveLicense: (license: VwpTeamMemberLicense) => void;
    isRemovingLicense?: boolean;
}

export function LicenseList({licenses, onRemoveLicense, isRemovingLicense = false}: LicenseListProps) {
    const hasLicenses = licenses && licenses.length > 0;

    return (
        <div className="space-y-3">
            <Label>{t('common.team.assignedLicenses')}</Label>

            {hasLicenses ? (
                <div className="space-y-2">
                    {licenses.map((license) => (
                        <div key={license.id}
                             className="flex items-center justify-between gap-2 p-3 rounded-lg border bg-muted/50">
                            <span className="min-w-0 truncate" title={license.name}>{license.name}</span>
                            <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => onRemoveLicense(license)}
                                disabled={isRemovingLicense}
                            >
                                <Trash2 className="h-4 w-4 text-destructive"/>
                            </Button>
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-muted-foreground p-3 border rounded-lg bg-muted/30 break-words">
                    {t('common.team.noLicensesAssigned')}
                </p>
            )}
        </div>
    );
}